import React from 'react'
import { useQuery } from '@tanstack/react-query';
import { queryClient as qc } from 'keys';
import { getAreasFetch } from 'store/middlewares/newsletter.crud';

const useFields = () => {
    const { data: systemAreas } = useQuery({
        queryKey: qc.systemAreas,
        queryFn: async () => {
            const { data } = await getAreasFetch()
            return data
        },
        refetchOnWindowFocus: false,
    })

    const fields = React.useMemo(
        () => [
            {
                name: "system_area",
                component: "autoComplete",
                options: systemAreas,
                getOptionLabel: (opt) => opt.label,
                placeholder: "אזור",
                className: "_area",
                borderRadius: 10
            },
            {
                name: "official_release_date",
                component: "datePicker",
                placeholder: "תאריך פרסום",
                className: "_date",
                borderRadius: 10
            },
            {
                name: "name",
                component: "input",
                placeholder: "שם הפיצ'ר",
                className: "_name",
                borderRadius: 10
            },
            {
                name: "description",
                component: "input",
                placeholder: "הסבר קצר",
                className: "_description",
                borderRadius: 10
            },
            {
                name: "image",
                component: "uploadFile",
                label: "תמונה ראשית",
                className: "_image",
                type: "image",
            }
        ],
        [systemAreas]
    );

    return fields
}

export default useFields 
